import { render } from "./PaginaHome.vue?vue&type=template&id=c4cf851a&scoped=true"
import script from "./PaginaHome.vue?vue&type=script&lang=js"
export * from "./PaginaHome.vue?vue&type=script&lang=js"

import "./PaginaHome.vue?vue&type=style&index=0&id=c4cf851a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4cf851a"]])

export default __exports__